(function () {
  // Start eines Drops: immer 19:00 Schweizer Zeit am angegebenen Tag (JJJJ-MM-TT).
  // Sommer- und Winterzeit werden automatisch beruecksichtigt (Korrektur 29.10.2026).
  // Die Funktion pcStartZeit nutzt auch der Countdown auf der Produktseite (layout/theme.liquid).
  function pcLetzterSonntag(jahr, monat) {
    // Letzter Sonntag eines Monats um 01:00 UTC, dann wird in Europa die Uhr umgestellt.
    var d = new Date(Date.UTC(jahr, monat + 1, 0, 1, 0, 0));
    d.setUTCDate(d.getUTCDate() - d.getUTCDay());
    return d.getTime();
  }

  function pcStartZeit(datum) {
    var teile = String(datum || '').split('-');
    if (teile.length !== 3) return NaN;
    var jahr = parseInt(teile[0], 10);
    var monat = parseInt(teile[1], 10) - 1;
    var tag = parseInt(teile[2], 10);
    // 17:00 UTC ist 19:00 Uhr Sommerzeit.
    var basis = Date.UTC(jahr, monat, tag, 17, 0, 0);
    if (isNaN(basis)) return NaN;
    var stunde = NaN;
    try {
      stunde = parseInt(new Intl.DateTimeFormat('en-GB', {
        timeZone: 'Europe/Zurich', hour: '2-digit', hourCycle: 'h23'
      }).format(new Date(basis)), 10);
    } catch (e) {}
    if (isNaN(stunde)) {
      // Ersatz fuer alte Browser: Sommerzeit vom letzten Sonntag im Maerz bis zum letzten Sonntag im Oktober.
      var sommer = basis >= pcLetzterSonntag(jahr, 2) && basis < pcLetzterSonntag(jahr, 9);
      stunde = sommer ? 19 : 18;
    }
    return basis + (19 - stunde) * 3600000;
  }

  window.pcStartZeit = pcStartZeit;

  function tick() {
    var now = Date.now();
    document.querySelectorAll('[data-pc-mini-timer]').forEach(function (el) {
      var target = pcStartZeit(el.dataset.start);
      var diff = target - now;
      if (isNaN(target) || diff <= 0) { el.hidden = true; return; }
      var d = Math.floor(diff / 86400000);
      var h = Math.floor(diff / 3600000) % 24;
      var m = Math.floor(diff / 60000) % 60;
      el.querySelector('[data-pc-mini-value]').textContent =
        d > 0 ? d + (/^en/i.test(document.documentElement.lang || '') ? 'd ' : 'T ') + h + 'h ' + m + 'min' : h + 'h ' + m + 'min';
      el.hidden = false;
    });
  }
  tick();
  setInterval(tick, 60000);
})();
